<script>
  import { fade, fly } from "svelte/transition";
  import { onMount } from "svelte";

  let ready = false;

  onMount(() => (ready = true));
</script>

<div class="row">
  {#if ready}
    <h1
      in:fade={{ delay: 100, duration: 1000 }}
      class="blue-grey-text text-darken-4 center-align"
    >
      Luis Fernando Camacho
    </h1>
    <h2
      in:fly={{ y: 25, duration: 500, delay: 500 }}
      class="blue-grey-text text-darken-2 center-align"
    >
      Visual Artist
    </h2>
  {/if}
</div>

<style>
  @media screen and (min-width: 1021px) {
    h1 {
      font-size: 6em;
    }
  }
  @media screen and (min-width: 1021px) {
    h2 {
      font-size: 2.5em;
    }
  }
  @media screen and (max-width: 1020px) {
    h1 {
      font-size: 4.5em;
    }
  }
  @media screen and (max-width: 1020px) {
    h2 {
      font-size: 2em;
    }
  }
  @media screen and (max-width: 400px) {
    h1 {
      font-size: 3em;
    }
    h2 {
      font-size: 1.75em;
    }
  }
</style>
